function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon-40x40-Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.0470129,4.62068272 L22.2425863,4.78539816 L37.6205919,18.7661165 C38.3016722,19.385312 38.3518398,20.4393938 37.7326443,21.1204741 C37.157677,21.7529058 36.2077313,21.8413362 35.5296472,21.3549799 L35.3782866,21.2325265 L34.9994444,20.8884748 L35,33.3333333 C35,35.090603 33.6402037,36.5302752 31.9154372,36.6575238 L31.6666667,36.6666667 L8.33333333,36.6666667 C6.57606367,36.6666667 5.13639146,35.3068703 5.00914289,33.5821039 L5,33.3333333 L4.99944441,20.8884748 L4.62227547,21.2325265 C3.94119516,21.851722 2.88711335,21.8015544 2.26791784,21.1204741 C1.69295059,20.4880424 1.69513821,19.533992 2.24369525,18.9051632 L2.37997019,18.7661165 L17.7579758,4.78539816 C18.9658274,3.68729524 20.7786629,3.63239009 22.0470129,4.62068272 Z M20.0002811,7.25180813 L8.33244441,17.8584748 L8.33333333,33.3333333 L16.6664444,33.3324748 L16.6666667,25 C16.6666667,23.1590508 18.1590508,21.6666667 20,21.6666667 C21.8409492,21.6666667 23.3333333,23.1590508 23.3333333,25 L23.3324444,33.3324748 L31.6666667,33.3333333 L31.6664444,17.8584748 L20.0002811,7.25180813 Z",
  id: "Combined-Shape",
  fill: "#60CAA8"
}));

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.e1367342.svg";
export { ForwardRef as ReactComponent };